<template>
    <div class="p-1 md:py-0 md:px-2 m-auto max-w-[1920px]" :class="{ 'container max-w-(--breakpoint-xl)': !isWide }">
        <slot />
    </div>
    <GlobalModal />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router/auto";
import GlobalModal from "@/components/GlobalModal.vue";

const route = useRoute();
const WIDE_ROUTES = ["/play", "/replay/", "/live/"];
const isWide = computed(() => route.path === "/" || WIDE_ROUTES.some((prefix) => route.path.startsWith(prefix)));
</script>
